import React from "react";
import { Box } from "@mui/material";
import PRTable from "../../PRTable";
import MetricCard from "../../MetricCard";
import styles from "./reportsDashboard.module.scss";

interface PREntry {
  prId: string;
  specialist: {
    name: string;
    initials: string;
    avatarColor?: string;
  };
  status: "In Review" | "Approved" | "Delayed" | "Pending";
  assignedDate: string;
  estDate: string;
  delay: {
    type: "on-track" | "delayed";
    days?: number;
  };
}

interface ReportsDashboardProps {
  activePRs?: PREntry[];
  topSavings?: {
    value: string;
    subtitle: string;
  };
  bestPCT?: {
    value: string;
    subtitle: string;
  };
  completionRate?: {
    value: string;
    subtitle: string;
  };
}

const ReportsDashboard: React.FC<ReportsDashboardProps> = ({
  activePRs = [],
  topSavings,
  bestPCT,
  completionRate,
}) => {
  return (
    <>
      <PRTable title="Active Purchase Requisitions" data={activePRs} />

      <Box className={styles.metricsSection}>
        {topSavings && (
          <MetricCard
            type="savings"
            title="Top Savings"
            value={topSavings.value}
            subtitle={topSavings.subtitle}
          />
        )}
        {bestPCT && (
          <MetricCard
            type="pct"
            title="Best PCT"
            value={bestPCT.value}
            subtitle={bestPCT.subtitle}
          />
        )}
        {completionRate && (
          <MetricCard
            type="completion"
            title="Completion Rate"
            value={completionRate.value}
            subtitle={completionRate.subtitle}
          />
        )}
      </Box>
    </>
  );
};

export default ReportsDashboard;
